import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
import Project from 'src/store/models/Project';
export default {
  props: {
    onPhasesSelected: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    }
  },
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      source: null,
      filter: '',
      presets: [{
        name: this.$t('components.copyPhaseCategoryDialog.marketing_preset'),
        key: 'marketing',
        phases: [this.$t('phases.social_media'), this.$t('phases.blog'), this.$t('phases.analytics')]
      }, {
        name: this.$t('components.copyPhaseCategoryDialog.developer_preset'),
        key: 'developer',
        phases: [this.$t('phases.bugfix'), this.$t('phases.feature'), this.$t('phases.design'), this.$t('phases.testing'), this.$t('phases.meeting')]
      }, {
        name: this.$t('components.copyPhaseCategoryDialog.sales_preset'),
        key: 'sales',
        phases: [this.$t('phases.calls'), this.$t('phases.meeting'), this.$t('phases.accounting'), this.$t('components.copyPhasesDialog.management')]
      }, {
        name: this.$t('components.copyPhaseCategoryDialog.customer_service_preset'),
        key: 'customer',
        phases: [this.$t('phases.calls'), this.$t('phases.development'), this.$t('phases.bugfix'), this.$t('phases.meeting'), this.$t('phases.support')]
      }],
      selectedPreset: null,
      projects: [],
      selectedProject: null,
      loading: true // presets

    };
  },
  computed: {
    filteredProjects: function filteredProjects() {
      var _this = this;

      return this.projects.filter(function (project) {
        if (_this.filter.length) {
          return project.name.toLowerCase().includes(_this.filter.toLowerCase());
        }

        return true;
      });
    }
  },
  methods: {
    phasesNames: function phasesNames(phases) {
      var _this2 = this;

      var names = phases.map(function (p) {
        return _this2.decodeHtmlEntities(p.name);
      });

      if (phases.length > 4) {
        var diff = phases.length - 4;
        names = names.slice(0, 4);
        names.push("+ ".concat(diff, " ").concat(this.$t('general.other', diff).toLowerCase()));
      }

      return names;
    },
    selectPhases: function selectPhases() {
      var _this3 = this;

      if (this.source === 'projects') {
        if (this.selectedProject) {
          this.onPhasesSelected(this.selectedProject.phases.map(function (p) {
            return {
              is_open: !!p.is_open,
              name: _this3.decodeHtmlEntities(p.name),
              task_category_id: p.task_category_id,
              budget_minutes: 0,
              total_minutes: 0
            };
          }));
          this.hide();
        } else {
          this.$q.notify({
            type: 'negative',
            message: this.$t('components.copyPhaseCategoryDialog.select_project_for_phases')
          });
        }
      } else if (this.source === 'presets') {
        if (this.selectedPreset) {
          this.onPhasesSelected(this.selectedPreset.phases.map(function (p) {
            return {
              is_open: 1,
              name: p,
              task_category_id: -1,
              budget_minutes: 0,
              total_minutes: 0
            };
          }));
          this.hide();
        } else {
          this.$q.notify({
            type: 'negative',
            message: this.$t('components.copyPhaseCategoryDialog.select_present_for_phases')
          });
        }
      }
    },
    loadProjects: function loadProjects() {
      var _this4 = this;

      this.source = 'projects';
      this.loading = true;
      Project.api().get('/projects').then(function () {
        return _this4.load();
      }).catch(function () {}).finally(function () {
        _this4.loading = false;
      });
    },
    load: function load() {
      this.projects = Project.query().with('phases').get();
    }
  }
};